// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1d749571","239":"c5270292","455":"99a886af"}[chunkId] + ".chunk.js";
};